<template>
    <div class="flex-grid__g-4 u-flex-grow-none">
        <line-chart :chart-data="chartData" :options="chartOptions" :width="160" :height="90"></line-chart>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import currencyFormat from 'mixins/currencyFormat';
    import LineChart from 'components/graphs/LineChart.js';

    export default {
        name: 'linegraph',
        components: {
            LineChart,
        },
        mixins: [
            currencyFormat,
        ],
        props: {
            title: {
                type: String,
                default: null,
            },
            legend: {
                type: Boolean,
                default: true,
            },
            dataset: {
                type: Array,
                default: null,
            },
            labels: {
                type: Array,
                default: null,
            }
        },
        computed: {
            chartData: {
                get() {
                    return {
                        labels: this.labels,
                        datasets: this.dataset,
                    }
                },
            },
            chartOptions: {
                get() {
                    return {
                        scales: {
                            xAxes: [
                                {
                                    id: 'xAxisLabels',
                                    categoryPercentage: 0.7,
                                    barPercentage: 0.7,
                                },
                                {
                                    id: 'xAxisLinear',
                                    type: "linear",
                                    display: false,
                                    ticks: {
                                        min: 0,
                                        max: 100,
                                        suggestedMin: 0,
                                        suggestedMax: 100
                                    }
                                }
                            ],
                            yAxes: [
                                {
                                    id: 'yAxisMain',
                                    scaleLabel: {
                                        display: true,
                                        labelString: 'Amount (£)'
                                    }
                                },
                                {
                                    id: 'yAxisSimple',
                                    display: false,
                                    type: 'linear',
                                    min: 0,
                                    max: 1,
                                },
                            ]
                        },
                        responsive: true,
                        maintainAspectRatio: true,
                        legend: {
                            display: this.legend,
                            position: 'top',
                            labels: {
                                boxWidth: 60,
                                fontSize: 16,
                                fontFamily: "'Nunito', sans-serif",
                                fontColor: "#000",
                                padding: 40,
                            },
                        },
                        tooltips: {
                            callbacks: {
                                label: (tooltipItem, data) => {
                                    return this.currencyFormat(data.datasets[tooltipItem.datasetIndex]['data'][tooltipItem.index]);
                                },
                            },
                        },
                        title: {
                            display: true,
                            text: '',
                        },
                    };
                },
            },
        }
    }
</script>



// WEBPACK FOOTER //
// Linegraph.vue?78be09fd